/*eslint-disable*/
import React from "react";
import "../../Assests/Globalcss/stylesheet.css";
import White_logo_footer from "../../Assests/Globalimages/white-logo.png";
// import Giff from "../../Assests/Globalimages/gif.gif";
// import Thankyou_gif from "../../Assests/Globalimages/";
import { useNavigate } from "react-router-dom";
const index = () => {
  const navigate = useNavigate()
  return (
    <div>
      <section class="footer-top">
        <div class="footer-content"></div>
        <div class="main-footer">
          <div class="ftr_top">
            <div class="container">
              <div class="row justify-content-center">
                <div class="col-lg-3">
                  <div class="footer-logo-w">
                    <img
                      class="nd-logo img-fluid"
                      src={White_logo_footer}
                      alt=""
                    />
                    <p class="text-white">
                      © 2023 | <a style={{cursor : 'pointer'}} onClick={()=>navigate("/PrivacyPolicy")} >Privacy Policy</a>
                    </p>
                    <p class="text-white">
                      <a href="mailto:office@venturerev.com">
                        <i class="fas fa-envelope me-2"></i>
                        office@venturerev.com
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- Modal 1 --> */}
      <div
        class="modal fade contactfrm-popup-main contactfrm-popup--width"
        id="thankYouModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="thankYouModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <button
                type="button"
                class="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i class="fa-solid fa-xmark"></i>
              </button>
              <div class="contactfrm_pop bg-white">
                <div
                  class="w-100 text-center"
                  style={{ position: " relative" }}
                >
                  {/* <img
                    class="text-center gif-confirm img-fluid"
                    src={Giff}
                    alt=""
                  /> */}
                  <p class="text-center">
                    Thank you! Our team will reach out to you in the next 72
                    hours.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Modal 2 --> */}
      <div
        class="modal fade contactfrm-popup-main contactfrm-popup--width"
        id="thankYouModall"
        tabindex="-1"
        role="dialog"
        aria-labelledby="thankYouModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <button
                type="button"
                class="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i class="fa-solid fa-xmark"></i>
              </button>
              <div class="contactfrm_pop bg-white">
                <div class="w-100 text-center" style={{ position: "relative" }}>
                  {/* <img
                    class="text-center gif-confirm img-fluid"
                    src="assets/images/video/thank_you.gif"
                    alt=""
                  /> */}
                  <p class="text-center">
                    Thank you! Our team will reach out to you in the next 72
                    hours.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default index;
